import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Roles } from './hooks/auth.hook'

import { AuthPage } from './pages/AuthPage'

import { LessonsPage } from './pages/LessonsPage'
import { ExperiencesPage } from './pages/ExperiencesPage'
import { SettingsPage } from './pages/SettingsPage'
import { DataPage } from './pages/DataPage'

import { ClientsPage } from './pages/ClientsPage'
import { ClientDetailPage } from './pages/ClientDetailPage'

import { QuizDetailPage } from './pages/QuizDetailPage'
import { UsersPage } from './pages/UsersPage'

import { ChangePasswordPage } from './pages/ChangePasswordPage'

/*
<Route path="/" exact>
          <AuthPage />
        </Route>
         <Redirect to="/" />
*/

export const useRoutes = (isAuthenticated, role) => {
  if (!isAuthenticated)
    return (
      <Switch>
        <Route path="/user/change-password/:ticket" exact>
          <ChangePasswordPage />
        </Route>
        <Route path="/" exact>
          <AuthPage />
        </Route>
        <Redirect to="/" />
      </Switch>
    )
  else {
    if (role === Roles.Admin)
      return (
        <Switch>
          <Route path="/lessons" exact>
            <LessonsPage />
          </Route>
          <Route path="/experiences" exact>
            <ExperiencesPage />
          </Route>
          <Route path="/data" exact>
            <DataPage />
          </Route>
          <Route path="/clients" exact>
            <ClientsPage />
          </Route>
          <Route path="/client/:id" exact>
            <ClientDetailPage />
          </Route>
          <Route path="/users" exact>
            <UsersPage />
          </Route>
          <Route path="/quiz/:id" exact>
            <QuizDetailPage />
          </Route>
          <Route path="/settings" exact>
            <SettingsPage />
          </Route>
          <Route path="/user/change-password/:ticket" exact>
            <ChangePasswordPage />
          </Route>

          <Redirect to="/lessons" />
        </Switch>
      )
    else if (role === Roles.Moderator)
      return (
        <Switch>
          <Route path="/data" exact>
            <DataPage />
          </Route>
          <Route path="/client" exact>
            <ClientDetailPage />
          </Route>
          <Route path="/users" exact>
            <UsersPage />
          </Route>
          <Route path="/quiz/:id" exact>
            <QuizDetailPage />
          </Route>
          <Route path="/user/change-password/:ticket" exact>
            <ChangePasswordPage />
          </Route>

          <Redirect to="/client" />
        </Switch>
      )
    else if (role === Roles.Officer)
      return (
        <Switch>
          <Route path="/users" exact>
            <UsersPage />
          </Route>
          <Route path="/data" exact>
            <DataPage />
          </Route>
          <Route path="/user/change-password/:ticket" exact>
            <ChangePasswordPage />
          </Route>

          <Redirect to="/users" />
        </Switch>
      )
    else if (role === Roles.Analytic)
      return (
        <Switch>
          <Route path="/data" exact>
            <DataPage />
          </Route>
          <Route path="/user/change-password/:ticket" exact>
            <ChangePasswordPage />
          </Route>

          <Redirect to="/data" />
        </Switch>
      )
    else
      return (
        <Redirect to="/" />
      );
  }
};
